
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employer/job-positions",
      function () {
        return require("private-next-pages/employer/job-positions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employer/job-positions"])
      });
    }
  